import styled, { css } from 'styled-components';
import tokens from '../../../../foundation/tokens/js/tokens';
// styled-components.
// -----------------------------------------------------------------------------
export const TableRowRoot = styled.tr `
  ${({ selected }) => selected &&
    css `
      &:nth-child(odd),
      &:nth-child(even) {
        &.selected {
          background-color: ${tokens.colors.active[100].value};
          font-weight: ${tokens.font.weight.bold.value};
        }
      }
    `}
`;
//# sourceMappingURL=TableRow.styled.js.map